export default class SecurityQuestionAnswerModel {
    id: number;
    answer: string;
    answerStored: boolean;
}
